import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents';
import { IUser } from '~/models';
import { TNullable } from '~/types/Nullable';
import { useCompanyMatchLabel } from '../../hooks';

interface ICompanyMatchLabelProps {
  offerOwnerId: string;
  professional: TNullable<IUser>;
  hasWorkedWithDSO?: boolean;
  hasWorkedWithOffice?: boolean;
}

export const CompanyMatchLabel = ({
  offerOwnerId,
  professional,
  hasWorkedWithDSO = false,
  hasWorkedWithOffice = false,
}: ICompanyMatchLabelProps) => {
  const data = useCompanyMatchLabel({
    offerOwnerId,
    professional,
    hasWorkedWithDSO,
    hasWorkedWithOffice,
  });

  if (!data) {
    return null;
  }

  return (
    <Box
      alignItems="center"
      justifyContent="center"
      backgroundColor={colors.primary[100]}
      borderRadius={4}
      height={20}
      paddingInline={8}
      width="fit-content"
    >
      <Typography as="span" bold color={colors.secondary[800]} size="caption_sm" uppercase>
        {data.label}
      </Typography>
    </Box>
  );
};
